// Standard-rate works are priced ex-VAT; UK deliveries get 20% added at checkout.
export const addsUkVat = (artwork) =>
  (artwork?.vatScheme || 'standard') === 'standard' && artwork?.vatExclusive !== false;
